"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TizenCapabilities = (function () {
    function TizenCapabilities() {
    }
    TizenCapabilities.prototype.hasLifecycleSuspension = function () {
        return true;
    };
    TizenCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    TizenCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    TizenCapabilities.prototype.hasVolumeControl = function () {
        return false;
    };
    TizenCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return TizenCapabilities;
}());
exports.TizenCapabilities = TizenCapabilities;
